module.exports = __webpack_public_path__ + "img/hook_MARTEC_BK_2.4de5d54e.png";